import script from "./coverage-dependent-table.vue?vue&type=script&setup=true&lang=js"
export * from "./coverage-dependent-table.vue?vue&type=script&setup=true&lang=js"

import "./coverage-dependent-table.vue?vue&type=style&index=0&id=e68ccc72&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e68ccc72"]])

export default __exports__